module.exports = __webpack_public_path__ + "static/media/5DPO1.4307abc7.jpg";